import { SET_TECHNIQUES, REMOVE_TECHNIQUE, PUSH_TECHNIQUE,
  SET_OFFER_TECHNIQUES, REMOVE_OFFER_TECHNIQUE, PUSH_OFFER_TECHNIQUE } from '../constants/techniques';

const initialState = {
  list: [],
  offerList: [],
};

const techniquesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TECHNIQUES:
      return {
        ...state,
        list: action.list.map(i => ({value: i.id, label: i.name}))
      };
    case REMOVE_TECHNIQUE:
      return {
        ...state,
        list: state.list.filter(o => o.value !== action.id),
      };
    case PUSH_TECHNIQUE:
      return {
        ...state,
        list: state.list.concat({value: action.data.id, label: action.data.name})
                        .sort((a, b) => a.label.localeCompare(b.label)),
      };
    case SET_OFFER_TECHNIQUES:
      return {
        ...state,
        offerList: [...action.list]
      };
    case REMOVE_OFFER_TECHNIQUE:
      return {
        ...state,
        offerList: state.offerList.filter(o => o.id !== action.id),
      }
    case PUSH_OFFER_TECHNIQUE:
      return {
        ...state,
        offerList: state.offerList.concat(action.data),
      };
    default:
      return state;
  }
};

export default techniquesReducer;